import { clsx } from 'clsx';

import { COLOR_KEYS } from '../../theme/themeColors.types';
import type { ColorKey } from '../../theme/themeColors.types';
import type { ReeferBaseProps } from '../../utils/baseProps.types';
import { getColorCSSVar } from '../../utils/colors';
import styles from './loading.module.css';

type LoadingSize = 'xs' | 'sm' | 'lg';

export interface LoadingProps extends ReeferBaseProps {
  /** Accepts one of the three to determine loading color, defaults to purple */
  color?: ColorKey | string;

  /** Size determines the height and width of the loading animation, defaults to sm */
  size?: LoadingSize;
}

export function Loading({
  className,
  color = 'grays-black',
  'data-testid': testId,
  id,
  size = 'sm',
  style,
}: LoadingProps) {
  const loadingColor = (COLOR_KEYS as readonly string[]).includes(color)
    ? getColorCSSVar(color as ColorKey)
    : color;
  return (
    <div
      className={clsx(
        className,
        styles['loading__container'],
        styles[`loading__container--${size}`]
      )}
      aria-busy="true"
      aria-live="polite"
      data-testid={testId}
      id={id}
      role="alert"
      title="loading animation"
    >
      <span
        className={clsx(
          styles['loading__animated'],
          styles[`loading__animated--${size}`]
        )}
      >
        <div
          className={clsx(
            styles['loading__wavvy'],
            styles[`loading__wavvy--${size}`]
          )}
          style={{
            '--loading-fill-color':
              loadingColor !== 'currentColor' ? loadingColor : undefined,
            ...style,
          }}
        />
      </span>
    </div>
  );
}
